/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_Schwab_NetworkInputs */

const en_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const de_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const pt_br2_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const tr_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const zh_cn2_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const zh_hk2_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const ko_kr2_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const ru_ru2_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

const es_419_onboarding_v1_press_schwab_network = /** @type {(inputs: Onboarding_V1_Press_Schwab_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwab Network`)
};

/**
* | output |
* | --- |
* | "Schwab Network" |
*
* @param {Onboarding_V1_Press_Schwab_NetworkInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_schwab_network = /** @type {((inputs?: Onboarding_V1_Press_Schwab_NetworkInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_Schwab_NetworkInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_schwab_network(inputs)
	if (locale === "de") return de_onboarding_v1_press_schwab_network(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_schwab_network(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_schwab_network(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_schwab_network(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_schwab_network(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_schwab_network(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_schwab_network(inputs)
	return es_419_onboarding_v1_press_schwab_network(inputs)
});